import styled from 'styled-components';

export const FormUploadStyle = styled.div`
  .ant-upload {
    width: 90px;
    // height: 90px;
    background-color: var(--bg-content);
    border-radius: 10px;
  }
`;

export const ImageItemStyle = styled.div<{ isFocus: boolean }>`
  width: 100px;
  height: 100px;
  background-color: var(--bg-content);
  border-radius: 10px;
  position: relative;
  img {
    width: 100px;
    height: 100px;
    background-color: var(--bg-content);
    border-radius: 10px;
  }
  video {
    width: 100px;
    height: 100px;
    background-color: var(--bg-content);
    border-radius: 10px;
  }
  .custom-action {
    width: 100%;
  }
  .overlay-view {
    position: absolute;
    top: 0px;
    left: 0px;
    right: 0px;
    bottom: 0px;
    width: 100px;
    height: 100px;
    border-radius: 10px;
    background-color: var(--loading-bg);

    align-items: center;
    justify-content: center;
    ${({ isFocus }) =>
      isFocus
        ? `
    display: flex;
    flex-direction: column;
    .anticon {
      color: white;
    }`
        : 'display: none;'};
  }
  &:hover {
    .overlay-view {
      display: flex;
      flex-direction: column;
      .anticon {
        color: white;
      }
    }
  }
  .highlight-label {
    position: absolute;
    top: 10px;
    left: 10px;
  }
`;

export const PreviewModalStyle = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const DropdownStyle = styled.div`
  border-radius: 10px;
  overflow: hidden;
  .ant-dropdown-menu {
  }
  .ant-dropdown-menu-item-group-title {
    padding: 0px !important;
    .ant-btn {
      border-radius: 0px;
      &:hover {
        background-color: var(--bg-primary);
        color: white;
      }
    }
  }
`;
